import React from 'react'
// import { Dropdown } from 'components/Core'
import { Card } from 'components/Core/Card/Card'
// import { Context } from 'data/context'
// import { IAppTheme, themes } from 'hooks/useAppTheme'
import { Link } from 'react-router-dom'

export const Home = () => {
    // @ts-ignore
    // const [context, setContext] = useContext(Context)
    // const [theme, setTheme] = useState({ value: 'light', label: 'Light'})

    // const handleChangeTheme = (newTheme: { value: IAppTheme, label: string }) => {
    //     setTheme(newTheme)
    //     // setContext({ ...context, theme: newTheme })
    // }

    // TODO convert this to css module
    const styles = {
        homeCard: {
            padding: '4rem',
            maxWidth: '50%',
            minWidth: '12rem',
            margin: 'auto',
            backgroundColor: '#FFF'
        }
    }

    return (
        <div>
            {/* TODO: fix theme switcher */}
            {/*
            <div style={{ width: '8rem', marginLeft: 'auto', marginRight: 'auto', marginBottom: '2rem', }}>
                <Dropdown
                    value={theme}
                    options={themes}
                    onChange={(item: any) => {
                        handleChangeTheme(item)
                    }}
                />
            </div>
            */}
            <Link to="/charts?timeInterval=90">
                <Card
                    id="prices"
                    style={styles.homeCard}>
                    <div>Prices</div>
                </Card>
            </Link>
            <br />
            <br />
            <Link to="/charts/bundle?productCode=RVX10">
                <Card
                    id="bundles"
                    style={styles.homeCard}>
                    <div>Bundles</div>
                </Card>
            </Link>
            <br />
            <br />
            <Link to="/calculate">
                <Card
                    id="calculate"
                    style={styles.homeCard}>
                    <div>Calculate</div>
                </Card>
            </Link>
        </div>
    )
}
